<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">成本中心代码：</span>
        </div>
        <el-input v-model="formData.costCenterCode" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">成本中心描述：</span>
        </div>
        <el-input v-model="formData.costCenterDescCn" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">关联主体住户：</span>
        </div>
        <el-select v-model="companyCodes"
                   filterable
                   remote
                   reserve-keyword
                   :remote-method="remoteMethod"
                   size="small" style="width: 280px"
                   placeholder="请选择关联主体住户">
          <el-option v-for="item in categoryList" :key="item.code"
                     :label="item.desc" :value="item.code">
          </el-option>
        </el-select>
      </div>
    </form>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { bus } from "../../../utils/bus";
import { api } from "../../api/Group";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "basic-information-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "数据对接",
          name: "customer-master-data"
        },
        {
          value: "利润/成本中心"
        }
      ],
      mainTitle: "添加利润/成本中心",
      subheading: "",
      formData: {},
      categoryList: [],
      companyCodes: ""
    };
  },
  created() {
    this.remoteMethod();
  },
  methods: {
    remoteMethod(query) {
      this.getDaliDictItemList(query);
    },
    confirm() {
      if (!this.formData.costCenterCode) {
        nError("请输入成本中心代码");
        return false;
      }
      if (!this.formData.costCenterDescCn) {
        nError("请输入成本中心描述");
        return false;
      }
      if (!this.formData.companyCode) {
        nError("请选择关联主体住户");
        return false;
      }
      this.$axios
        .post(api.addDaliCostCenter, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.$router.push({
              name: "cost-center"
            });
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.$router.push({
        name: "cost-center"
      });
    },
    getDaliDictItemList() {
      this.$axios
        .post(api.getDaliDictItemList, { dictType: "主体住户" })
        .then(res => {
          this.categoryList = res.data.data;
        })
        .catch(errorHandler("获取列表失败"));
    }
  },
  watch: {
    companyCodes(val) {
      this.categoryList.map(v => {
        if (v.code == val) {
          this.formData.companyCode = v.value;
          this.formData.companyName = v.desc;
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/DataSync/CostCenter/CostCenterAdd.vue